import { readCheckoutLeagueId } from './checkoutLeagueContext';
import { lscPath } from './routing';

/** Resolve league id from checkout return query or session storage. */
export function resolveCheckoutLeagueId(queryLeagueId?: string | null): string | undefined {
  const fromQuery = (queryLeagueId || '').trim();
  if (fromQuery) return fromQuery;
  return readCheckoutLeagueId();
}

/** Wizard return path after Stripe checkout success or cancel. */
export function buildSetupSubscriptionReturnPath(leagueId?: string | null): string | null {
  const id = (leagueId || '').trim() || readCheckoutLeagueId();
  if (!id) return null;
  return lscPath(`/leagues/${id}/setup?step=subscription`);
}
